import { checkProviderRequirements } from './api';
import {
  isProviderMainUser,
  logProviderRequirementsCheck,
  logProviderRequirementsSkipped,
} from './providerRequirementsCheck';
import { fetchCurrentUser } from '../ducks/user.duck';

/**
 * Re-run provider requirements check via server API and log results (Phase A — no /s filtering).
 *
 * @param {{ source: string, refreshUser?: boolean }} options
 */
export const recheckProviderRequirements =
  ({ source, refreshUser = false }) =>
  (dispatch, getState) => {
    let chain = Promise.resolve();

    if (refreshUser) {
      chain = chain.then(() =>
        dispatch(
          fetchCurrentUser({ enforce: true, updateHasListings: false, updateNotifications: false })
        )
      );
    }

    return chain.then(() => {
      const { currentUser } = getState().user;
      const userId = currentUser?.id?.uuid;

      if (!userId) {
        logProviderRequirementsSkipped('not logged in', { source });
        return null;
      }

      if (!isProviderMainUser(currentUser)) {
        logProviderRequirementsSkipped('not a provider-main account', { source });
        return null;
      }

      return checkProviderRequirements({ userId })
        .then(response => {
          logProviderRequirementsCheck(response, { source });
          return response;
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(`[provider-requirements][${source}] Check failed:`, error.message || error);
          throw error;
        });
    });
  };
